import React, {PureComponent} from 'react';
import {toast} from "react-toastify";
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom'
import axios from "../../axios-defaults";
import UserContext from '../../context/user-context';

import PageTitle from "../../components/Commons/PageTitle";
import CardBoard from "../../components/Cards/CardBoard";
import CardSummaryRequests from "../../components/Cards/CardSummaryRequests";
import AccountsList from "../../components/Accounts/AccountsList";
import Spinner from "../../components/UI/Spinner";
import Aux from "../../hoc/Auxiliary"
import Faq from "../Faq/Faq";
import FidelityPts from "../../components/UI/FidelityPts";
import Banner from '../../components/UI/Banner';

import {userHaveSpecificPermission} from "../../components/Utils/UserHelper";

class Dashboard extends PureComponent {
    static contextType = UserContext;

    constructor(props) {
        super(props);

        this.state = {
            account: null,
            lastInvoice: null,
            serviceRequests: null,
            loading: false,
            loadingAccount: false,
            loadingServiceRequests: false,
			userIdentified: false,
        }
    }

    componentDidMount() {
        this.getInvoices();
        this.getAccount();
    }
	componentDidUpdate(prevProps, prevState, snapshot) {
		const userId = this.context?.user?.infos?.user_id;

		// If user_id becomes available and hasn't been identified yet
		if (userId && !this.state.userIdentified) {
			this.setState({ userIdentified: true });
			this.identifyUser(userId);
		}
	}

	identifyUser = (userId) => {
		window.userGuiding.identify(userId, {
			has_invoices: Boolean(this.state.lastInvoice),
		});
	};

    getAccount = async() => {
        this.setState({loadingAccount: true});
        await axios.get(`/accounts`)
            .then(response => {
                if (response.data.succeeded) this.setState({account: response.data.data});
                this.setState({loadingAccount: false});
            }).catch(error => {
            this.setState({loadingAccount: false});
            console.log('[Dashboard.js] : Account ajax error in getAccount()', error.message);
        });
    }

    getInvoices = async() => {
        this.setState({loading: true});

        await axios.get(`/accounts/invoiceHeaders?pageNumber=1&pageSize=1`)
            .then(response => {
                //console.log('[Dashboard.js] Invoice Ajax raw response',response.data);
                if (response.data.succeeded) {
                    if (response.data.data.length > 0) {
                        this.setState({lastInvoice: response.data.data[0]});
                    }
                }
                this.setState({loading: false});
            }).catch(error => {
            console.log('[Dashboard.js] : Invoices ajax error in getInvoices()', error.message);
            this.setState({loading: false});
        });
    }

    render() {
        const user = this.context.user;
        const { t } = this.props;


        let userName = "";
        if (user.infos) {
            userName = user.infos.firstname;
        }

        let html = <div className="container container--larger"><br/><Spinner styleName=""/></div>;
        if (user.infos && user.account) {

            html = (
                <Aux>
                    <div className="container container--larger">

                        <div className="row">
                            <div className="col-lg-6">
                                <PageTitle title={this.props.t('dashboard.title')}/>
                                <p className='welcome-message'>
                                    {this.props.t('dashboard.greeting', {username: userName || ""})}
                                </p>
                            </div>
                            <div className="col-lg-6 d-flex align-items-end justify-content-end">
                                {
                                    user.account && user.account.proxiCardNumber !== "" &&
                                       <FidelityPts account={user.account} />
                                }
                            </div>
                        </div>
						<Banner />
                        {userHaveSpecificPermission(user, 'financial_data') && user.infos.permission === 'complete' ? (
                            <div className="row">
                                <div className="col-12 col-lg-7 p-lg-0 order-1 order-lg-0">
                                    <CardSummaryRequests />
                                </div>

                                <div className="col-12 col-lg-5 p-lg-0">
                                    <CardBoard title={this.props.t('dashboard.invoices.title')}
                                               data={this.state.lastInvoice}
                                               account={this.state.account}
                                               link="/invoices#invoices"
                                               link_accountstatement="/invoices#statements"
                                               link_priceletter="/documents#letter"
                                               loading={this.state.loading}
                                               loadingAccount={this.state.loadingAccount}
                                    />
                                </div>
                            </div>
                        ) : null}
                        <AccountsList isSummary={true}/>
                    </div>
                    <div className="homefaq">
                        <div className="container">
                            <h3 className="headline headline--block headline--c-white">{t("faq.needhelp")}</h3>
                            <p className="p--c-white">
                            {t("faq.introtext")}
                            </p>
                            <div className="accordions__block accordions__block--dashboard">
                               <Faq view="dashboard" />
                            </div>
                            <div className="d-flex justify-content-center">
                                <Link to={"faq"} className="btn btn--outline btn--outline--white">
                                    {t("faq.btn")}
                                    &nbsp;&nbsp; <i className="fas fa-angle-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </Aux>
            )
        }

        return html
    }
}

export default withTranslation()(Dashboard);
